import React, {useMemo} from 'react';
import theme from '@/style';
import {debounce} from '@/utils';
import {packageId} from '@/config';

const FILTER_MENU = [
  {
    name: 'Kerala',
    hideIds: [5, 101],
  },
  {
    name: '3 Digit',
    hideIds: [5, 101],
  },
  {
    name: 'Color',
  },
  {
    name: 'Dice',
  },
  {
    name: 'Satta Matka',
    hideIds: [5, 101],
  },
  {
    name: 'Scratch off',
  },
  {
    name: 'Casino',
  },
  {
    name: 'Live',
  },
  {
    name: 'Racecar',
    value: 'Quick Race',
  },
  {
    name: 'Quick 3D',
    hideIds: [5, 101],
  },
  {
    name: 'Sports',
    hideIds: [101],
  },
  {
    name: 'State Lottery',
  },
  {
    name: 'Quick State Lottery',
  },
];

const BetsFilter = (props: {
  value?: string;
  onChange?: (v: string) => void;
}) => {
  const {value = 'Kerala', onChange = () => {}} = props;
  const filterList = useMemo(() => {
    return FILTER_MENU.filter(v => {
      if (v.hideIds) {
        return v.hideIds.indexOf(packageId) === -1;
      }
      return true;
    });
  }, []);

  const changeName = debounce((name: string, realValue?: string) => {
    onChange(realValue || name);
  });

  return (
    <div style={stylesWeb.wrap}>
      <div style={stylesWeb.scroll}>
        {filterList.map((item, index) => {
          const currentValue = item.value || item.name;
          const selected = value === currentValue;
          return (
            <div
              key={index}
              onClick={() => changeName(item.name, item.value)}
              role="button"
              style={{
                ...stylesWeb.item,
                ...(selected ? stylesWeb.itemSelected : null),
              }}
              tabIndex={0}>
              <span
                style={{
                  ...stylesWeb.text,
                  color: selected
                    ? theme.basicColor.primary
                    : theme.basicColor.dark,
                }}>
                {item.name}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BetsFilter;

const stylesWeb: Record<string, React.CSSProperties> = {
  wrap: {
    backgroundColor: '#fff',
    height: '3.3125rem',
    overflowX: 'auto',
    overflowY: 'hidden',
  },
  scroll: {
    display: 'inline-flex',
    alignItems: 'center',
    height: '100%',
    padding: '0 0.75rem',
    minWidth: '100%',
    boxSizing: 'border-box',
  },
  item: {
    appearance: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid transparent',
    backgroundColor: '#F6F7FB',
    borderRadius: '9999px',
    height: '2rem',
    padding: '0 0.75rem',
    boxSizing: 'border-box',
    marginRight: '0.5rem',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    outline: 'none',
    boxShadow: 'none',
  },
  itemSelected: {
    borderColor: theme.basicColor.primary,
    backgroundColor: '#fff',
  },
  text: {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    fontWeight: 500,
  },
};
